import { CleaningType } from "Types";

export const CleaningTypeSelectOptions = [
  { label: "Unknown", value: CleaningType.UNKNOWN },
  { label: "Basic Cleaning", value: CleaningType.BASIC },
  { label: "Deep Cleaning", value: CleaningType.DEEP },
  { label: "Custom Cleaning", value: CleaningType.CUSTOM },
];
